import React, { Component } from "react";
import FacilityCustomizeResults from "./FacilityCustomizeResults";
import AUX from "../../../hoc/Aux_";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import * as Permissions from "../../Permissions/PermissionValues";
import AuthService from "../../Auth/AuthService";
import FacilityColumnsService from "./FacilityColumnsService";
import { toast } from "react-toastify";

class FacilitiesCustomizer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  canCustomizeResults = () => {
    return AuthService.canView(Permissions.Customize_Fields);
  };

  customizeDialogClosed = (requiresRefresh, selectedFields) => {
    this.setState({
      showModal: false,
    });
    if (this.props.forceRefresh) {
      this.props.forceRefresh(requiresRefresh, selectedFields);
    }
  };

  quickResetToDefaults = async () => {
    try {
      const success = await FacilityColumnsService.ResetColumnPreferences(
        this.props.memberId
      );

      if (success) {
        // Clear localStorage
        localStorage.removeItem("FacilityColumns_" + this.props.memberId);

        // Get defaults
        const defaults = await FacilityColumnsService.GetDefaultColumns();
        if (defaults && defaults.length > 0) {
          // Trigger refresh with new defaults
          if (this.props.forceRefresh) {
            this.props.forceRefresh(true, defaults);
          }
        }
      }
    } catch (error) {
      toast.error("Error resetting to defaults");
    }
  };

  render() {
    if (this.canCustomizeResults() !== true) {
      return null;
    }

    return (
      <AUX>
        <div className="inline-item">
          <UncontrolledDropdown className="inline-item facility-filter">
            <DropdownToggle tag="a" className="nav-link-font-size" style={{ cursor: "pointer" }}>
              <i
                className="fas fa-cog"
                title="Customize Facility Columns"
              ></i>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-body">
              <DropdownItem
                className="dropdown-item-custom"
                onClick={() => {
                  this.setState({
                    showModal: true,
                  });
                }}
              >
                <i className="fas fa-pencil-alt ffi"></i>
                Customize Columns
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem
                className="dropdown-item-custom"
                onClick={this.quickResetToDefaults}
              >
                <i className="fas fa-undo ffi"></i>
                            {" "}Reset to Defaults
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>

          <FacilityCustomizeResults
            showModal={this.state.showModal}
            memberId={this.props.memberId}
            customizeDialogClosed={this.customizeDialogClosed}
            selectedFields={this.props.selectedFields}
          />
        </div>
      </AUX>
    );
  }
}

export default FacilitiesCustomizer;
